"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

exports.encode = encode;
exports.decode = decode;

var _htmlEntities = require("html-entities");

var _isPlainObject = require("lodash/isPlainObject");

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * All HTML entitites decoding.
 */
/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

var entities = new _htmlEntities.AllHtmlEntities();

function shallowWalk(input, options, functor) {
  if (typeof input !== "string") {
    return input;
  }

  return functor(input);
}

function walk(input, _ref, functor) {
  var deep = _ref.deep;

  if (typeof input === "string") {
    return functor(input);
  }

  var mapper = deep ? walk : shallowWalk;

  if (Array.isArray(input)) {
    return input.map(function (entry) {
      return mapper(entry, { deep: deep }, functor);
    });
  }

  if ((0, _isPlainObject2.default)(input)) {
    return (0, _keys2.default)(input).reduce(function (entries, entry) {
      entries[entry] = mapper(input[entry], { deep: deep }, functor);

      return entries;
    }, {});
  }

  return input;
}

function mapEncoder(type) {
  switch (type) {
    case "nonUTF":
      return entities.encodeNonUTF;

    case "nonASCII":
      return entities.encodeNonASCII;

    case "all":
    default:
      return entities.encode;
  }
}

function getEncoder(_ref2) {
  var type = _ref2.type;

  var encoder = mapEncoder(type);

  return function (input) {
    return encoder(input);
  };
}

var decoder = function (input) {
  return entities.decode(input);
};

function encode(input /*: string | Array | Object*/) /*: string*/ {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref3$deep = _ref3.deep,
      deep = _ref3$deep === undefined ? true : _ref3$deep,
      _ref3$type = _ref3.type,
      type = _ref3$type === undefined ? "all" : _ref3$type;

  return walk(input, { deep: deep }, getEncoder({ type: type }));
}

function decode(input /*: string | Array | Object*/) /*: string*/ {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref4$deep = _ref4.deep,
      deep = _ref4$deep === undefined ? true : _ref4$deep;

  return walk(input, { deep: deep }, decoder);
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@novivia/utilities/formats/htmlEntities.js
// module id = 37
// module chunks = 6